import React from 'react';
import { Table } from 'react-bootstrap';

const OvertimeTotalFilterDataTable = ({ attendancesTotal }) => {
  const renderData = () => {
    return (
      <>
        <Table className="custom-data-table" bordered size="sm" style={{ fontWeight: 400 }}>
          <thead className="rdt_TableHeadRow" style={{ backgroundColor: '#EBEBEB', textTransform: 'uppercase' }}>
            <tr className="rdt_TableCol">
              <th className="text-center align-middle">Días consultados</th>
              <th className="text-center align-middle">Al Inicio Jornada</th>
              <th className="text-center align-middle">Al Termino Jornada</th>
              <th className="text-center align-middle">Por Colación</th>
              <th className="text-center align-middle">Por Marcación Sin turno</th>
              <th className="text-center align-middle">Autorizadas Inicio Jornada</th>
              <th className="text-center align-middle">Autorizadas Termino Jornada</th>
            </tr>
          </thead>
          <tfoot>
            <tr>
              <td className="text-center align-middle">{attendancesTotal.consulting_days}</td>
              <td className="text-center align-middle">{attendancesTotal.total_extra_hours_begin || '00:00:00'}</td>
              <td className="text-center align-middle">{attendancesTotal.total_extra_hours_end || '00:00:00'}</td>
              <td className="text-center align-middle">{attendancesTotal.total_extra_hours_collation || '00:00:00'}</td>
              <td className="text-center align-middle">{attendancesTotal.total_extra_hours_out_shift || '00:00:00'}</td>
              <td className="text-center align-middle">
                {attendancesTotal.total_overtime_request_bigin || '00:00:00'}
              </td>
              <td className="text-center align-middle">{attendancesTotal.total_overtime_request_end || '00:00:00'}</td>
            </tr>
          </tfoot>
        </Table>
      </>
    );
  };

  return <>{renderData()}</>;
};

export default OvertimeTotalFilterDataTable;
